import { Camera, Actor, Engine, Vector, vec } from "excalibur";

export const centerCameraStrategy = (
  camera: Camera,
  actor: Actor,
  threshold: number,
  roomTileMapWidth
) => {
  // Store previous position
  let previousPosition = actor.pos.clone();

  return {
    target: actor, // Required target property
    action: (
      target: Actor,
      camera: Camera,
      engine: Engine,
      delta: number
    ): Vector => {
      const actorPosition = actor.pos;
      const cameraCenter = camera.pos;

      const distanceY = Math.abs(cameraCenter.y - actorPosition.y);
      const distanceX = Math.abs(actorPosition.x - cameraCenter.x);

      // Check if the actor is moving and determine direction
      const movingRight =
        Math.floor(actorPosition.x) > Math.floor(previousPosition.x);
      const movingLeft =
        Math.floor(actorPosition.x) < Math.floor(previousPosition.x);
      const movingDown =
        Math.floor(actorPosition.y) > Math.floor(previousPosition.y); // Actor is moving down if current y is greater
      const movingUp =
        Math.floor(actorPosition.y) < Math.floor(previousPosition.y); // Actor is moving up if current y is less

      previousPosition = actorPosition.clone();

      // If the room is small, keep the camera centered
      if (roomTileMapWidth <= window.innerWidth) {
        return cameraCenter.clone();
      }


      // Horizontal movement logic
      if ((distanceX <= threshold && movingLeft) || movingRight) {
        // Return the position to center the actor horizontally
        return vec(actor.center.x, cameraCenter.y);
      }

      // Vertical movement logic
      if ((distanceY <= 600 && movingDown) || movingUp) {
        // Return the position to center the actor vertically
        return vec(cameraCenter.x, actor.center.y);
      }

      // Otherwise, keep the camera at its current position
      return cameraCenter.clone();
    },
  };
};
